import { render, staticRenderFns } from "./RewardsBadgeWithColor.vue?vue&type=template&id=045a459b"
import script from "./RewardsBadgeWithColor.vue?vue&type=script&lang=ts"
export * from "./RewardsBadgeWithColor.vue?vue&type=script&lang=ts"
import style0 from "./RewardsBadgeWithColor.vue?vue&type=style&index=0&id=045a459b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports